import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  GetCity():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/City/GetDB`);
  }
  GetCityById(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/City/GetByIdDB?Id=${id}`);
  }
  GetCityPaged(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/City/GetPagedDB`,data);
  }
  GetCityByGovernorateId(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/City/GetDB?governorateId=${id}`);
  }
  DeleteCity(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/City/Delete?id=${id}`);
  }

  CreateCity(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/City/Create`,data);
  }
  UpdateCity(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/City/Update`,data)
  }
}
